import React, { useState, useContext } from "react";
import { Layout, Popover } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import UserInfo from "components/UserInfo";
import AppNotification from "components/AppNotification";
import MailNotification from "components/MailNotification";
import Auxiliary from "util/Auxiliary";
import { context } from '../../context';
import ViewportContext from '../../context/Viewport/viewportContext'

import SidebartContext from '../../context/sidebar/sidebarContext'

import styles from './index.module.scss';

const { Header } = Layout;

const Topbar = () => {

  const { state, actions } = useContext(context);
  const { navStyle, authUser } = state
  // const { navCollapsed, navStyle, authUser } = state

  //instance of the viewport context
  const viewportContext = useContext(ViewportContext);
  const { width } = viewportContext

  //instance of the viewport context
  const sidebartContext = useContext(SidebartContext);
  const { navCollapsed, toggleCollapsedSideNav } = sidebartContext

  const [searchText, setSearchText] = useState('');

  return (

    <Header>

      <div className="gx-linebar gx-mr-3">
        <i className="gx-icon-btn icon icon-menu"
          onClick={toggleCollapsedSideNav}
        />
      </div>


      <div className={`gx-linebar ${styles.logo_container}`}>
        <img alt="logo2" src={require("assets/images/logos/250Logo.png")} />
      </div>



      {/* <Link to="/" className="gx-d-block gx-d-lg-none gx-pointer">
        <img alt="" src={require("assets/images/w-logo.png")} /></Link> */}



      <ul className="gx-header-notifications gx-ml-auto">
        <Auxiliary>
          <li className="gx-notify">
            <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={<AppNotification />}
              trigger="click">
              <span className="gx-pointer gx-d-block"><i className="icon icon-notification" /></span>
            </Popover>
          </li>

          <li className="gx-msg">
            <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight"
              content={<MailNotification />} trigger="click">
              <span className="gx-pointer gx-status-pos gx-d-block">
                <i className="icon icon-chat-new" />
                <span className="gx-status gx-status-rtl gx-small gx-orange" />
              </span>
            </Popover>
          </li>
        </Auxiliary>
        <Auxiliary>
          <li className="gx-user-nav"><UserInfo /></li>
        </Auxiliary>
      </ul>
    </Header>

  );
};

export default Topbar;